import {
    ResourceStatementAutocompleteKey,
    ResourceStatementFormBody,
    ResourceStatementFormGlobal,
    ResourceStatementFormHeader,
    ResourceStatementMultiselectFilterParamKey, ResourceStatementTabs
} from 'components/Projects/PageBody/ResourceStatement/ResourceStatement.types.ts';
import {
    autocompleteChangeArg,
    autocompleteFieldDefault,
    autocompleteSubmitArg,
    multiselectFieldDefault
} from 'utils/inputs.tsx';
import { AutocompleteSubmitData, InputChangeArg, InputSubmitArg } from 'types/inputs.ts';

// *
// SELECT FUNCS
// *

export const resourceStatementTabs: ResourceStatementTabs[]  = [
    { value: 'works-by-stage', label: 'Этапам' },
    { value: 'works-by-date', label: 'Дате доставки' },
]


export const resourceStatementFormHeaderInitialState: ResourceStatementFormHeader = {
    name: '',
}
export const resourceStatementFormBodyInitialState: ResourceStatementFormBody = {
    materialType: autocompleteFieldDefault,
    inventoryType: multiselectFieldDefault,
    stages: multiselectFieldDefault,
    status: '',

}

export const resourceStatementFormBodyInitialState1: ResourceStatementFormGlobal = {
    name: '',
    materialType: autocompleteFieldDefault,
    inventoryType: multiselectFieldDefault,
    stages: multiselectFieldDefault,
    status: '',
}

export const onMaterialTypesAutocompleteSubmit = ({ key, setFormValue }: InputSubmitArg<ResourceStatementAutocompleteKey, ResourceStatementFormGlobal>) => (data: AutocompleteSubmitData) => {
    setFormValue(key, autocompleteSubmitArg(data))
}

export const onMaterialTypesAutocompleteChange = ({ formData, key, setFormValue }: InputChangeArg<ResourceStatementAutocompleteKey, ResourceStatementFormGlobal>) => (label: string) => {
    if (formData[key]?.name!==label) {
        setFormValue(key, autocompleteChangeArg(label))
    }
}

export const onInventoryTypeMultiselectChange = ({ formData, key, setFormValue }: InputChangeArg<ResourceStatementMultiselectFilterParamKey, ResourceStatementFormGlobal>) => (label: string) => {
    if (formData[key]?.name !== label) {
        setFormValue(`${key}.name`, label)
    }
}
export const onInventoryTypeMultiselectSubmit = ({ key, setFormValue }: InputSubmitArg<ResourceStatementMultiselectFilterParamKey, ResourceStatementFormGlobal>) => (valueIds: Array<string>) => {
    setFormValue(`${key}.ids`, valueIds)
}